// extracted by mini-css-extract-plugin
export default {"onCallUserContainer":"OnCallUserInfo_onCallUserContainer__tuJ6f","onCallUserText":"OnCallUserInfo_onCallUserText__jbljg"};